import ResponsiveImage from "../../atoms/image/ResponsiveImage";

export default function CtaSecondaryWithoutShadow({ data, className }) {
  const appMode = process.env.APP_MODE;
  const link = data?.cta?.href?.[appMode] || data?.cta?.href;
  return (
    <section
      className={`customise-wrap has-content-${
        data.image.align === `right` ? `left` : `right`
      } container grid--wrap br-8 lg:mt-20 lg:mb-20 md:mb-10 md:mt-10 ${className}`}
    >
      <ResponsiveImage
        dpi={data.image.prefixes.dpi}
        mobile={data.image.prefixes.mobile}
        src={data.image.src}
        alt={data.image.alt}
        wrapClass={`${data.image.align === `right` ? `fx--o-1` : ``}`}
      />
      <article className="lg:maxw-md text-left md:fx--o-1">
        <h2
          className="text-lg"
          dangerouslySetInnerHTML={{ __html: data.title }}
        />
        {Array.isArray(data.desc) ? (
          data.desc.map((item, index) => {
            return (
              <p
                key={index}
                dangerouslySetInnerHTML={{ __html: item }}
                className="mt-2"
              />
            );
          })
        ) : (
          <p dangerouslySetInnerHTML={{ __html: data.desc }} />
        )}
        <a href={link} className="btn-primary mt-5 md:w-100">
          <span dangerouslySetInnerHTML={{ __html: data.cta.text }} />
        </a>
        {data.hasOwnProperty("compliance") && (
          <p
            className="text-xs text-lg-grey mt-5"
            dangerouslySetInnerHTML={{ __html: data.compliance }}
          />
        )}
      </article>
    </section>
  );
}
